import { Form } from "@rjsf/mui";
import { useParams } from "react-router-dom";
import validator from "@rjsf/validator-ajv6";
import { useState, useEffect, useMemo } from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { loadingOff, loadingOn } from "../redux/slices/loadingSlice";
import { useSelector, useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";
import { setMessage } from "../redux/slices/snackbarSlice";

import { condominiumApi } from "../redux/slices/condominiumApi";
import { setTreeItem, setBtnDetector } from "../redux/slices/condominiumSlice";
import { TreeItem, TreeView } from "@mui/lab";
import { setPosDirection } from "../redux/slices/condominiumSlice";
import { setAppIndex } from "../redux/slices/condominiumSlice";
import LongNameWrapper from "../utils/LongNameWrapper";
import { ChevronRightOutlined, ExpandMoreOutlined } from "@material-ui/icons";
import { setSubCondominiumIdentifier } from "../redux/slices/condominiumSlice";
import GatewayShow from "../components/gateway/GatewayShow";
import { store } from "../redux/store";
import ApartamentConsumtionsTab from "./ApartamentConsumtionsTab";
import { cleanMeterId } from "../redux/slices/condominiumSlice";
import {
  setAppTopAllowed,
  setAppBotAllowed,
} from "../redux/slices/condominiumSlice";

import {
  setApartametnMeterModal,
  setApartamentIdentifier,
  setApartamentName,
  setActualAppPos,
  setSubConName,
} from "../redux/slices/condominiumSlice";
import { setTreeExpanded } from "../redux/slices/condominiumSlice";

import { CondominiumTree } from "../components/condominium/CondominiumTree";
import ApartamentMeter from "../components/condominium/ApartamentMeter";
import ModalDialog from "../components/meters/ModalDialog";
import CondominiumTabs from "../components/condominium/CondominiumTabs";
import ApartamentReadingTab from "./ApartamentReadingTab";

const sortChildrenByPosition = (children) => {
  return [...children]?.sort(
    (a, b) => a.attributes?.position - b.attributes?.position
  );
};

const ObjectFieldTemplate = (props) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="flex-end"
      rowSpacing={3}
      spacing={2}
    >
      {props.properties.map((element, i) => {
        /* if (i == 5 || i == 4) {
                    return (
                      <Grid key={element.id} alignItems="center" item xs={12}>
                        {element.content}
                      </Grid>
                    );
                  } */
        return (
          <Grid key={element.id} alignItems="center" item xs={6}>
            {element.content}
          </Grid>
        );
      })}
    </Grid>
  );
};
const flutEnums = [
  { const: "Piano interrato -2" },
  { const: "Piano interrato -1" },
  { const: "Piano terra" },
  { const: "Piano marciapiede" },
  { const: "Piano 1" },
  { const: "Piano 2" },
  { const: "Piano 3" },
  { const: "Piano 4" },
  { const: "Piano 5" },
  { const: "Piano 6" },
  { const: "Piano 7" },
  { const: "Piano 8" },
  { const: "Piano 9" },
  { const: "Piano 10" },
];
/**
 * A custom component for displaying and managing sub-condominium details.
 *
 * @component TextFieldNumber
* @returns {JSX.Element}.
 
 *
 */
export const ApartmentShow = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [topElement, setTopElement] = useState(null);
  const apartamentIdentifier = useSelector(
    (state) => state.condominiumSlice.apartamentIdentifier
  );
  const [botElement, setBotElement] = useState(null);
  const [selectedElement, setSelctedElement] = useState(null);
  const [getMeterId] = store.useLazyGetMetertIdQuery();
  const [getSubconId] = store.useLazyGetSubCondominiumIdQuery();
  const [
    updateApartament,
    { isSuccess: updateApSuccess, isLoading: updateLoading },
  ] = store.useUpdateCondominiumIfnoMutation();
  const appBarIsOpen = useSelector(
    (state) => state?.utilsSlice?.headerAppBarOpen
  );
  const posDirection = useSelector(
    (state) => state?.condominiumSlice?.posDirection
  );
  const apartamentMeter = useSelector(
    (state) => state.condominiumSlice.apartamentMeter
  );
  const condominiumShow = useSelector(
    (state) => state?.condominiumSlice?.condominiumShow
  );
  const apartamentMeterModal = useSelector(
    (state) => state.condominiumSlice.apartamentMeterModal
  );
  const maxAparamentPosition = useSelector(
    (state) => state?.condominiumSlice?.maAxppPos
  );
  const apartamentIndex = useSelector(
    (state) => state?.condominiumSlice?.apartamentIndex
  );
  const nextPos = maxAparamentPosition + 1;
  const [firstRender, setFirstRender] = useState(false);
  const autoLoading = useSelector((state) => state?.loadingSlice?.autoLoading);
  const loading = useSelector((state) => state?.loadingSlice?.loading);
  const meterId = useSelector((state) => state?.condominiumSlice?.meterId);
  const [formData, setFormData] = useState({});
  const [readyForCreate, setReadyForCreate] = useState(false);
  const subCondominiumIdentifier = useSelector(
    (state) => state.condominiumSlice.subCondominiumIdentifier
  );
  const treeExpanded = useSelector(
    (state) => state?.condominiumSlice?.treeExpanded
  );
  const condominiumTreeData = useSelector(
    (state) => state?.condominiumSlice?.condominiumTreeData
  );
  const data = useSelector((state) => state?.condominiumSlice?.condominiumShow);
  const subConName = useSelector(
    (state) => state?.condominiumSlice?.subCondominiumName
  );
  const [createApartament, { isSuccess: createApartamentSuccess }] =
    store.useCreateApartmentMutation();
  const [getCondominiumShow, { isFetching }] =
    store.useLazyCondominiumShowQuery();
  const { id, subCondominumName, apartmentName } = useParams();
  /*   const { getCond } = store.useLazyCondominiumShowQuery(id); */

  const subCondominiumId = useSelector(
    (state) => state?.condominiumSlice?.subCondominiumId
  );
  const condominiumId = useSelector(
    (state) => state?.condominiumSlice?.condominiumId
  );

  const regex = /^gateway$/i;
  const subcondominium = useMemo(() => {
    return (data?.children?.filter(
      (c) => c.attributes?.name === subCondominumName
    ) ?? [])[0];
  }, [data, subCondominumName]);
  useEffect(() => {
    console.log("pissed&popped", data);
  }, [data]);
  const sortedApartments =
    subcondominium && sortChildrenByPosition(subcondominium.children);
  const apartment = useMemo(() => {
    return (subcondominium?.children?.filter(
      (c) => c.attributes?.name === apartmentName
    ) ?? [])[0];
  }, [apartmentName, subcondominium]);
  const gateway = useMemo(() => {
    return (subcondominium?.children?.filter(
      (c) =>
        regex.test(c?.attributes?.class || "") &&
        c.attributes.name === apartmentName
    ) ?? [])[0];
  }, [apartmentName, subcondominium]);
  useEffect(() => {
    console.log("gafka", sortedApartments);
  }, [sortedApartments]);
  useEffect(() => {
    dispatch(setSubConName(subCondominumName));
  }, [subCondominumName]);
  useEffect(() => {
    if (updateApSuccess) {
      getCondominiumShow(id);
    }
  }, [updateApSuccess]);

  useEffect(() => {
    if (updateApSuccess) {
      dispatch(setMessage(t("update_success")));
      dispatch(loadingOff());
    }
  }, [updateApSuccess]);
  useEffect(() => {
    if (!condominiumShow) {
      getCondominiumShow(id);
    }
  }, [condominiumShow]);
  useEffect(() => {
    if (gateway && !meterId) {
      getMeterId(gateway?.attributes?.identifier);
      console.log("zalupka");
    }
  }, [gateway, meterId]);
  useEffect(() => {
    console.log("appazub", apartment);
  }, [apartment]);
  useEffect(() => {
    if (subcondominium) {
      dispatch(
        setSubCondominiumIdentifier(subcondominium?.attributes.identifier)
      );
    }
  }, [subcondominium]);
  useEffect(() => {
    if (apartment) {
      setFormData(apartment?.attributes);
      dispatch(setApartamentIdentifier(apartment?.attributes?.identifier));
      dispatch(setActualAppPos(+apartment?.attributes?.position));
    }
  }, [apartment]);
  useEffect(() => {
    dispatch(setApartamentName(apartmentName));
  }, [apartmentName]);
  useEffect(() => {
    if (createApartamentSuccess) {
      setTimeout(() => {
        getCondominiumShow(condominiumId);
        const newPath = window.location.pathname.replace("new", formData.name);
        navigate(newPath);
        dispatch(setTreeExpanded([...treeExpanded, subConName]));
        dispatch(loadingOff());
      }, 500);
    }
  }, [createApartamentSuccess]);
  useEffect(() => {
    setSelctedElement(sortedApartments?.[apartamentIndex]);
    setTopElement(sortedApartments?.[apartamentIndex - 1]);
    setBotElement(sortedApartments?.[apartamentIndex + 1]);
  }, [apartamentIndex]);
  useEffect(() => {
    console.log("obkekalsya", subcondominium);
  }, [subcondominium]);
  useEffect(() => {
    console.log("subCondominumNameFromAppart", subCondominumName);
  }, [subCondominumName]);
  const { t } = useTranslation();
  useEffect(() => {
    if (meterId) {
      dispatch(setBtnDetector(6));
    }
  }, [meterId]);

  const location = window.location.href;
  const ownercheck =
    apartamentMeter?.attributes?.fields.owner_name ===
      apartamentMeter?.attributes?.fields.occupant_name &&
    apartamentMeter?.attributes?.fields.owner_mail ===
      apartamentMeter?.attributes?.fields.occupant_mail &&
    apartamentMeter?.attributes?.fields.owner_phone_number ===
      apartamentMeter?.attributes?.fields.occupant_phone_number;
  const schema = {
    title: "New apartment",
    type: "object",
    properties: {
      flat: {
        $id: "1",
        type: "string",
        title: t("flat"),
        oneOf: [...flutEnums],
      },
      internal: {
        $id: "11",
        type: "string",
        title: t("internal"),
      },
      name: {
        $id: "2",
        type: "string",
        title: t("name"),
        readOnly: !location.includes("new") && true,
      },
      occupant_mail: {
        $id: "3",
        type: "string",
        title: t("occupant_mail"),
      },
      occupant_name: {
        $id: "4",
        type: "string",
        title: t("occupant_name"),
      },
      owner_mail: {
        $id: "5",
        type: "string",
        title: t("owner_mail"),
      },
      owner_name: {
        $id: "6",
        type: "string",
        title: t("owner_name"),
      },

      owner_phone_number: {
        $id: "9",
        type: "string",
        title: t("owner_phone_number"),
      },
      occupant_phone_number: {
        $id: "10",
        type: "string",
        title: t("occupant_phone_number"),
      },
      occupant_is_owner: {
        id: 7,
        type: "boolean",
        title: t("occupant_is_owner"),
      },
    },
    required: ["name"],
  };
  /*   useEffect(() => {
    getSubconId("95f41a24-ef0d-11ed-89ce-40b076d8dbd4");
  }, []); */
  useEffect(() => {
    console.log("ovchek", ownercheck);
  }, [ownercheck]);
  /**
   * Function that handles the "Create" or "Update" action for an apartment in the condominium.
   * If an existing apartment is being updated, it updates the apartment details using the 'updateApartament' function.
   * If a new apartment is being created, it prepares the attributes and sets 'readyForCreate' to true.
   */
  const onCreateClick = () => {
    dispatch(loadingOn());
    if (apartment) {
      const attributes = {
        fields: {
          occupant_is_owner: formData.occupant_is_owner,
          active_network_adapters:
            apartamentMeter.attributes?.fields?.active_network_adapters,
          class: apartamentMeter?.attributes.class,
          coordinates: apartamentMeter?.attributes?.coordinates,
          flat: formData.flat,
          identifier: apartamentMeter?.attributes?.fields?.identifier,
          identifier_type: apartamentMeter?.attributes?.fields?.identifier_type,
          master_key: apartamentMeter?.attributes?.fields?.master_key,
          name: apartamentMeter?.attributes?.fields?.name,
          serial_number: apartamentMeter?.attributes?.serial_number,
          network_adapters:
            apartamentMeter?.attributes?.fields?.network_adapters,
          occupant_mail: formData.occupant_mail,
          occupant_name: formData.occupant_name,
          occupant_phone_number: formData.occupant_phone_number,
          owner_mail: formData.owner_mail,
          owner_name: formData.owner_name,
          owner_phone_number: formData.owner_phone_number,
          parent: apartamentMeter?.attributes?.fields?.parent,
          security: apartamentMeter?.attributes?.fields?.security,
          status: apartamentMeter?.attributes?.fields?.status,
          tag: apartamentMeter?.attributes?.fields?.tag,
          sub_condominium_id: apartamentMeter?.id,
          internal: formData.internal,
          /*     position: "1", */
        },
        meta_data: {},
      };
      updateApartament({
        twinId: apartamentMeter?.attributes?.digital_twin_id,
        instanceId: apartamentMeter?.id,
        attributes: attributes,
      });
    } else {
      getSubconId(subCondominiumIdentifier);
      setReadyForCreate(true);
    }
  };
  useEffect(() => {
    console.log("elembot", botElement);
    console.log("elemtop", topElement);
    console.log("elemsel", selectedElement);
  }, [botElement]);
  useEffect(() => {
    if (sortedApartments?.length > 0) {
      const actualIndex = sortedApartments?.findIndex(
        (item) =>
          item?.attributes?.identifier ===
          apartamentMeter?.attributes?.identifier
      );
      dispatch(setAppIndex(actualIndex));
    }
  }, [sortedApartments]);
  useEffect(() => {
    if (apartamentIdentifier) {
      dispatch(setTreeItem(apartamentIdentifier));
    }
  }, [apartamentIdentifier]);
  useEffect(() => {
    if (subCondominiumId && readyForCreate) {
      const data = {
        ...formData,
        sub_condominium_id: +subCondominiumId,
        position: nextPos?.toString(),
      };
      createApartament(data)
        .unwrap()
        .then((data) => {
          dispatch(setTreeItem(data.data.attributes.fields.identifier));
          dispatch(setBtnDetector(3));
        });
      setReadyForCreate(false);
    }
  }, [subCondominiumId, readyForCreate]);
  useEffect(() => {
    dispatch(setBtnDetector(3));
  }, []);
  const uiSchema = {
    "ui:submitButtonOptions": {
      submitText: t("save"),
      classNames: "submit-button",
    },
    "ui:order": [
      "flat",
      "internal",
      "name",
      "occupant_name",
      "occupant_mail",
      "occupant_phone_number",
      "occupant_is_owner",
      "owner_name",
      "owner_mail",
      "owner_phone_number",
    ],
    "ui:ObjectFieldTemplate": ObjectFieldTemplate,
  };
  useEffect(() => {
    console.log("fmd", formData);
  }, [formData]);
  /*  useEffect(() => {
    return () => {
      window.sessionStorage.setItem("bcName", "");
    };
  }, []); */
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const customValidate = (formData, errors) => {
    if (formData.owner_mail !== "" && formData.owner_mail) {
      if (!emailRegex.test(formData.owner_mail)) {
        errors?.owner_mail?.addError(t("invalid_email"));
      }
    }
    if (formData.occupant_mail) {
      if (!emailRegex.test(formData.occupant_mail)) {
        errors?.occupant_mail?.addError(t("invalid_email"));
      }
    }
    return errors;
  };
  /**
   * Function that updates the details of the apartment in the upward direction.
   * If the 'updateLoading' flag is true, the function returns early without performing any updates.
   * Otherwise, it prepares the necessary attribute objects for the actual apartment and the one above it.
   * It then calls the 'updateApartament' function twice in sequence to update the attributes of both apartments.
   *
   * The 'updateApartament' function takes two parameters: 'twinId' and 'instanceId'.
   * - 'twinId' represents the digital twin ID associated with the apartment.
   * - 'instanceId' is the identifier of the specific instance of the apartment.
   *
   * The 'actualAttribuste' object contains the updated attributes for the current apartment:
   * - 'position': The current position value of the apartment is decreased by 1.
   * - 'coordinates': The coordinates of the apartmentMeter.
   * - 'serial_number': The serial number of the apartmentMeter.
   * - 'class': The class of the apartmentMeter.
   *
   *
   * The 'topAttributes' object contains the updated attributes for the apartment above the current one:
   * - 'position': The position of the apartment above is increased by 1.
   * - 'coordinates': The coordinates of the topElement.
   * - 'serial_number': The serial number of the topElement.
   * - 'class': The class of the topElement.
   *
   * After preparing the attribute objects, the function performs the updates asynchronously using promises.
   * Once the updates are completed, the function returns.
   */
  const topDirectionFunc = () => {
    if (updateLoading) {
      return;
    } else {
      const actualAttribuste = {
        fields: {
          position: (+selectedElement?.attributes?.position - 1)?.toString(),
          coordinates: apartamentMeter?.attributes?.coordinates,
          serial_number: apartamentMeter?.attributes?.serial_number,

          class: apartamentMeter?.attributes?.class,
        },
        meta_data: {},
      };
      const topAttributes = {
        fields: {
          position: (+topElement?.attributes?.position + 1).toString(),
          coordinates: topElement?.attributes?.coordinates,
          serial_number: topElement?.attributes?.identifier,
          class: topElement?.attributes?.class,
        },
        meta_data: {},
      };
      updateApartament({
        twinId: apartamentMeter?.attributes?.digital_twin_id,
        instanceId: apartamentMeter?.attributes?.fields?.identifier,
        attributes: actualAttribuste,
      }).then(() => {
        updateApartament({
          twinId: apartamentMeter?.attributes?.digital_twin_id,
          instanceId: topElement?.attributes?.identifier,
          attributes: topAttributes,
        });
      });
    }
  };
  /**
   * Function that updates the details of the apartment in the downward direction.
   * If the 'updateLoading' flag is true, the function returns early without performing any updates.
   * Otherwise, it prepares the necessary attribute objects for the actual apartment and the one below it.
   * It then calls the 'updateApartament' function twice in sequence to update the attributes of both apartments.
   *
   * The 'updateApartament' function takes two parameters: 'twinId' and 'instanceId'.
   * - 'twinId' represents the digital twin ID associated with the apartment.
   * - 'instanceId' is the identifier of the specific instance of the apartment.
   *
   * The 'actualAttribuste' object contains the updated attributes for the current apartment:
   * - 'position': The current position value of the apartment is increased by 1.
   * - 'coordinates': The coordinates of the apartmentMeter.
   * - 'serial_number': The serial number of the apartmentMeter.
   * - 'class': The class of the apartmentMeter.
   *
   *
   * The 'botAttributes' object contains the updated attributes for the apartment below the current one:
   * - 'position': The position of the apartment below is decreased by 1.
   * - 'coordinates': The coordinates of the botElement.
   * - 'serial_number': The serial number of the botElement.
   * - 'class': The class of the botElement.
   *
   * After preparing the attribute objects, the function performs the updates asynchronously using promises.
   * Once the updates are completed, the function returns.
   */
  const botDirectionFunc = () => {
    if (updateLoading) {
      return;
    } else {
      const actualAttribuste = {
        fields: {
          position: (+selectedElement?.attributes?.position + 1)?.toString(),
          coordinates: apartamentMeter?.attributes?.coordinates,
          serial_number: apartamentMeter?.attributes?.serial_number,

          class: apartamentMeter?.attributes?.class,
        },
        meta_data: {},
      };
      const botAttributes = {
        fields: {
          position: (+botElement?.attributes?.position - 1).toString(),
          coordinates: botElement?.attributes?.coordinates,
          serial_number: botElement?.attributes?.identifier,
          class: botElement?.attributes?.class,
        },
        meta_data: {},
      };

      updateApartament({
        twinId: apartamentMeter?.attributes?.digital_twin_id,
        instanceId: apartamentMeter?.attributes?.fields?.identifier,
        attributes: actualAttribuste,
      }).then(() => {
        updateApartament({
          twinId: apartamentMeter?.attributes?.digital_twin_id,
          instanceId: botElement?.attributes?.identifier,
          attributes: botAttributes,
        });
      });
    }
  };
  useEffect(() => {
    if (posDirection === "appTop") {
      topDirectionFunc();
      dispatch(setPosDirection(null));
    }
    if (posDirection === "appDown") {
      botDirectionFunc();
      dispatch(setPosDirection(null));
    }
  }, [posDirection]);
  useEffect(() => {
    if (!topElement) {
      dispatch(setAppTopAllowed(false));
    } else {
      dispatch(setAppTopAllowed(true));
    }
  }, [topElement]);

  useEffect(() => {
    if (!botElement) {
      dispatch(setAppBotAllowed(false));
    } else {
      dispatch(setAppBotAllowed(true));
    }
  }, [botElement]);
  useEffect(() => {
    console.log("pisihavka", formData.owner_mail);
  }, [formData.owner_mail]);
  useEffect(() => {
    if (formData.occupant_is_owner && formData.occupant_name) {
      setFormData((prev) => ({
        ...prev,
        owner_name: formData.occupant_name,
      }));
    }
    if (formData.occupant_is_owner && formData.occupant_mail) {
      setFormData((prev) => ({
        ...prev,
        owner_mail: formData.occupant_mail,
      }));
    }
    if (formData.occupant_is_owner && formData.occupant_phone_number) {
      setFormData((prev) => ({
        ...prev,
        owner_phone_number: formData.occupant_phone_number,
      }));
    }
    if (
      formData.occupant_is_owner &&
      formData.occupant_name?.length == undefined
    ) {
      setFormData((prev) => ({
        ...prev,
        owner_name: "",
      }));
    }
    if (
      formData.occupant_is_owner &&
      formData.occupant_mail?.length == undefined
    ) {
      setFormData((prev) => ({
        ...prev,
        owner_mail: "",
      }));
    }
    if (
      formData.occupant_is_owner &&
      formData.occupant_phone_number?.length == undefined
    ) {
      setFormData((prev) => ({
        ...prev,
        owner_phone_number: "",
      }));
    }
    /* if (!formData.occupant_is_owner) {
      setFormData((prev) => ({
        ...prev,
        owner_name: "",
        owner_mail: "",
        owner_phone_number: "",
      }));
    } */
  }, [
    formData.occupant_mail,
    formData.occupant_name,
    formData.occupant_phone_number,
    formData.occupant_is_owner,
  ]);
  useEffect(() => {
    if (apartamentMeter && apartamentMeter && ownercheck) {
      setFormData((prev) => ({
        ...prev,
        occupant_is_owner: true,
      }));
    }
  }, [apartamentMeter, apartamentMeter, ownercheck]);

  return (
    <>
      {!apartment && (
        <Typography sx={{ mb: 4 }} variant="h1">
          {t("new_apartament")}
        </Typography>
      )}
      {apartment && (
        <LongNameWrapper
          text={apartmentName}
          size={appBarIsOpen ? "75vw" : "95vw"}
          variant={"h1"}
          maxLength={100}
        />
      )}
      <ModalDialog
        title={"Associazione meter"}
        open={apartamentMeterModal}
        close={() => dispatch(setApartametnMeterModal(false))}
      >
        <ApartamentMeter />
      </ModalDialog>
      <Grid container>
        <Grid item xs={2}>
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            {condominiumTreeData && (
              <CondominiumTree
                condominium={condominiumTreeData}
                subcondominiumName={subCondominumName}
                apartmentName={apartmentName}
                apartment={apartment}
                subcondominium={subcondominium}
              />
            )}
          </Box>
        </Grid>
        {!meterId && !isFetching && (
          <Grid item xs={10}>
            <CondominiumTabs
              mainTab={
                <Form
                  schema={schema}
                  uiSchema={uiSchema}
                  //fields={fields}
                  formData={formData}
                  onSubmit={onCreateClick}
                  onChange={(changeEvent) => setFormData(changeEvent.formData)}
                  validator={validator}
                  showErrorList={false}
                  customValidate={customValidate}
                  noHtml5Validate
                />
              }
              readings={<ApartamentReadingTab condominiumId={id} />}
              consume={<ApartamentConsumtionsTab condominiumId={id} />}
            />
          </Grid>
        )}
        {meterId && !isFetching && (
          <Grid itex xs={9} sx={{ ml: 1 }}>
            <GatewayShow idFromCondominium={meterId} />
          </Grid>
        )}
      </Grid>
    </>
  );
};
